import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="analysis-selector"
export default class extends Controller {
  static targets = ["link"];

  connect() {
    console.log("Analysis selector controller connected");
    this.setupEventListeners();
  }

  setupEventListeners() {
    // Find all analysis selection links
    const analysisLinks = this.element.querySelectorAll(
      "a[href*='analysis_job_id']"
    );

    analysisLinks.forEach((link) => {
      link.addEventListener("click", this.handleAnalysisSelection.bind(this));
    });
  }

  handleAnalysisSelection(event) {
    // Prevent the default link behavior
    event.preventDefault();

    // Get the URL from the link
    const url = event.currentTarget.getAttribute("href");

    console.log("Navigating to:", url);

    // Force a full-page reload to the selected analysis
    window.location.href = url;
  }

  // This controller primarily relies on standard links in the dropdown,
  // but we could add functionality here if needed, such as:
  // - Analytics tracking for analysis switches
  // - Additional UI enhancements
  // - Confirmation dialogs for switching analyses
}
